import styled, { css } from 'styled-components'

const FormInputContainerBase = styled.div`
	display: block;

	&:not(:last-child) {
		margin-bottom: ${({ theme, hidden }) => hidden ? 0 : theme.formIdent};
	}

	&>div:not(:last-child) {
		margin-bottom: ${({ theme, hidden }) => hidden ? 0 : theme.formIdent};
	}

	label {
		margin-bottom: 0; /* If label is used above input */
	}

	&.hidden-field {
		margin-right: 0;
	}
	input[type=text], input[type=password], input[type=number], textarea {
		width: 100%;
		height: 36px;
		max-width: 300px;
		border-radius: 3px;
		font-size: 14px;
		font-weight: 300;
		background-color: #ffffff;
		box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.12);
		border: 1px solid transparent;
		padding: 0 13px;
		/* Override reset autofill styles */
		&:hover, &:focus {
			background-color: #ffffff;
			box-shadow: 0 2px 2px 0 rgba(90, 90, 90, 0.12);
			border: 1px solid transparent;
		}
	}
	textarea {
		padding: 10px 13px;
		height: 100px;
	}
	&:focus-within  {
		.label {
			font-weight: 400;
			color: ${({ theme }) => theme.fieldLabelColor};
		}
		input {
			font-weight: 400;
		}
	}

	.theme-light & {
		input[type=text], input[type=password], input[type=number], textarea {
			background-color: ${({ theme }) => theme.darkbgColor};
		}
	}

	${({ inline }) => inline && css`
		display: inline-block !important;
		&:not(:last-child) {
			margin-right: 20px;
		}
	`}
`

export default FormInputContainerBase
